<ng-container *ngFor="let serviceTypeGroup of vendorDetails.menuGroups">
  <div #group class="menu-group" [class.quick-add-to-cart]="quickAddToCart" *ngFor="let menuGroup of serviceTypeGroup.groups">
    <div class="menu-group-name">{{ menuGroup.name }}</div>

    <div class="menu-item-grid" *ngIf="quickAddToCart">
      <app-menu-item
        [item]="item"
        [vendorDetails]="vendorDetails"
        [quickAddToCart]="true"
        (itemSelected)="onMenuItemSelected(item, menuGroup.menuGroupId)"
        (itemDecremented)="onMenuItemDecremented(item, menuGroup.menuGroupId)"
        (itemIncremented)="onMenuItemIncremented(item, menuGroup.menuGroupId)"
        *ngFor="let item of menuGroup.menuItems"
      ></app-menu-item>
    </div>

    <ng-container *ngIf="!quickAddToCart">
      <app-menu-item
        [item]="item"
        [vendorDetails]="vendorDetails"
        (itemSelected)="onMenuItemSelected(item, menuGroup.menuGroupId)"
        (itemAvailabilityRequested)="onMenuItemAvailabilityRequested(item, menuGroup.menuGroupId)"
        *ngFor="let item of menuGroup.menuItems"
      ></app-menu-item>
    </ng-container>
  </div>
</ng-container>
